export const generalDeLegacy = {
  "catalogSelector.selected.single": "{items} ausgewählt",
  "catalogSelector.selected.multiple": "{items} und {lastItems} ausgewählt",
  "iconGallery.uploadResult.failMessage":
    "Beim Hochladen ist ein Fehler aufgetreten. Stellen Sie sicher, dass die Dateien den Anforderungen entsprechen\n{showFileList,select,true{{failed} von {total} fehlgeschlagen: {failedDetails}} andere {{failedDetails}}} ",
  "pointsRatesFields.perDescriptor.spend": "für jede/n/s",
  "activityElementMultiuplyPointsText.double": "Doppelt",
  "activityElementMultiuplyPointsText.triple": "Dreifach"
};
